import { AlertCircle } from "lucide-react";

interface ErrorDisplayProps {
  title: string;
  message: string;
  className?: string;
}

export const ErrorDisplay = ({
  title,
  message,
  className = "rounded-md bg-red-50 p-3 text-sm",
}: ErrorDisplayProps) => (
  <div className={`flex items-start gap-2 ${className}`}>
    <AlertCircle className="mt-0.5 h-4 w-4 flex-shrink-0 text-red-600" />
    <div className="text-red-800">
      <div className="font-medium">{title}</div>
      <div className="mt-1">{message}</div>
    </div>
  </div>
);
